const translations = {
  fax: "(fax)",
  phone: "(phone)"
};

export default translations;
